export default "__VITE_ASSET__CadN_E3f__"